import React from 'react';
import { Chip } from '@mui/material';

const AlChip = ({ color, size = 'small', backgroundColor, label, icon, sx }) => (
    <Chip
        color={color}
        size={size}
        sx={{
            backgroundColor,
            borderRadius: '4px',
            fontWeight: 700,
            borderWidth: '0px',
            pl: 0.25,
            ...sx,
        }}
        label={label}
        icon={icon}
        variant="outlined"
    />
);

export default AlChip;
